import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthStore } from '../stores/auth.store';
import { HOME_ROUTE } from './auth-route.constants';

const requireGuestSession = () => {
  const auth = inject(AuthStore);
  const router = inject(Router);

  return auth.waitUntilSessionReady().pipe(
    map(() => (auth.isAuthenticated() ? router.createUrlTree([HOME_ROUTE]) : true)),
  );
};

/** Redirects authenticated users away from sign-in and other public auth pages. */
export const guestGuard: CanActivateFn = () => requireGuestSession();

/** Same rule as {@link guestGuard}, for parent routes that only group children. */
export const guestChildGuard: CanActivateChildFn = () => requireGuestSession();
